<template>
<!--  <div v-if="isLoggedIn">-->
  <div :class="['on_page', { 'with-sidebar': isLoggedIn }]">
    <Toast/>
    <TopNavBar :isLoggedIn="isLoggedIn"/>
    <main class="main-content">
      <router-view/>
    </main>
  </div>
<!--  </div>-->
<!--  <div v-else>-->
<!--    <Toast />-->
<!--    <LoginPage />-->
<!--  </div>-->
</template>

<style lang="scss">
.on_page {
  min-height: 100vh;
}

.with-sidebar {
  align-items: stretch;
  background: #eef5f8;
  display: flex;
}

.main-content {
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  padding: 20px;
}

.app-container {
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  height: inherit;
  background: #F7F8F9;

  .app-content {
    margin: 8px;
  }
  .p-inputtext,
  .p-dropdown-label,
  .p-dropdown-filter,
  input,
  select,
  textarea {
    font-size: 16px !important;
  }
}

@media (max-width: 640px) {
  .with-sidebar {
    display: block;
  }

  .main-content {
    padding: 14px;
  }
}
</style>
<script>
import TopNavBar from "@/components/TopNavBar";
import LoginPage from "@/pages/LoginPage";
import {useStore} from "vuex";
import {computed} from "vue";

export default {
  components: {TopNavBar, LoginPage},
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);

    return {
      isLoggedIn
    }
  }
}
</script>
